import request from "@/utils/request";

// 获取公众号签名
export function getSign(params) {
  return request({
    url: "/talent-common/wechat/getSign",
    method: "GET",
    params,
  });
}